<template>
<div class="wrapper" >
  <video-player class="video-player-box vjs-big-play-centered"
    ref="videoPlayer"
    :options="playerOptions"
    :playsinline="true"
    customEventName="customstatechangedeventname">
  </video-player>
</div>
</template>

<script>
export default {
  props: ['postsrc', 'autoplay'],
  components: {
  },
  data () {
    return {
      playerOptions: {
        muted: false,
        autoplay: this.autoplay,
        language: 'en',
        fluid: true,
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [{
          type: 'video/mp4',
          src: '/videos/Assistenzhunde/Führen_SD_WEB.mp4'
        }],
        poster: ''
      }
    }
  },
  mounted () {
    this.playerSetSrc(this.postsrc)
  },
  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },
  methods: {
    playerSetSrc (url) {
      this.player.src(url)
    }
  }
}
</script>

<style scoped>
  .wrapper{
    display:flex;
    justify-content: center;
    align-items: center;
    height:100vh;
  }
  .video-player-box{
    width: 1066px;
    height: 600px;
  }

@media screen and (max-width: 1366px) {
  .video-player-box{
    width: 700px;
  }
}

@media screen and (max-width: 1024px) {
  .video-player-box{
    width: 550px;
  }
}

@media (orientation: landscape) and (max-width:981px){
  .wrapper{
    margin-top:15vh;
  }
  .video-player-box{
    width: 100%;
    height: 100%;
  }
}

@media screen and (max-width: 981px) {
  .wrapper{
    display:block;
    height:100%;
  }
  .video-player-box{
    width: 100%;
  }
}

@media (orientation: portrait) and (max-width: 981px) {
  .wrapper{
    display:flex;
    justify-content: center;
    align-items: center;
    height:100vh;
  }
  .video-player-box{
    width: 100%;
  }
}

</style>
